import { Component, h } from 'preact';
import linkState from 'linkstate';
import { route } from 'preact-router';

import getStore from '../../../store';
import * as InquiriesActions from '../../../reducers/inquiries/inquiries.actions';

import { HopplerModalizer } from '../../common/hoppler-modalizer.component';
import { InquiryDocument } from '../../../../../types/inquiries/inquiry-document.model';
import { ReqState } from '../../../../../types';
import { FileUploadFormControl } from '../../common/file-upload-form-control.component';
import { formatWithTimezone } from '../../../../core/date-formatter';
import { DatePickerControl } from '../../common/date-picker-control.component';

interface InqOfferAcceptedModalProps {
  documentChoices: InquiryDocument[];
  offerReqState: ReqState;
  submitState: ReqState;

  onClose: () => void;
  onSubmit: (loiKey: string, date: string, files: FileList) => void;
}

interface InqOfferAcceptedModalState {
  selectedLoiKey?: string;
  selectedFiles?: FileList;
  acceptedDate?: string;
}

const store = getStore();

export class InqOfferAcceptedModal extends Component<InqOfferAcceptedModalProps, InqOfferAcceptedModalState> {
  onSubmit(e: Event) {
    e.preventDefault();
    const state = this.state;

    const date = formatWithTimezone(state.acceptedDate);
    this.props.onSubmit(state.selectedLoiKey, date, state.selectedFiles);
  }

  onProceed() {
    route('/kumita-brokers/inquiries/offer-accepted?actionFrom=offer-accepted-modal');
    this.props.onClose();
  }

  onTransitionCloseClick() {
    store.dispatch(InquiriesActions.loadAllStages());
    this.props.onClose();
  }

  getOfferSelectionGroup() {
    const { documentChoices, offerReqState } = this.props;
    
    if (offerReqState === ReqState.SUCCESS) {
      if (documentChoices.length > 0) {
        return (
          <div className="hi-input-group">
            <label className="hi-input-group__label">Select an offer</label>
            {/* <input className="form-control" disabled value={ document.documentName || document.propertyAddress } /> */}
            <select className="form-control" onChange={ linkState(this, 'selectedLoiKey') } value={ this.state.selectedLoiKey }>
              { documentChoices.map(choice => (
                <option value={ choice.loiKey }>{ choice.documentName || choice.propertyAddress }</option>
              )) }
            </select>
          </div>
        );
      } else {
        return (
          <p className="mb-0">
            <strong className="text-danger d-block mb-2">This inquiry has no existing offers.</strong>
            Please create an offer before marking an offer as sent.
          </p>
        )
      }
    } else {
      return (
        <div className="hi-input-group">
          <label className="hi-input-group__label">Selected LOI</label>
          <input type="text" className="form-control" disabled placeholder="Loading offers for this inquiry..." />
        </div>
      );
    }
  }

  getSubmitButton() {
    if (this.props.submitState === ReqState.IN_PROGRESS) {
      return (
        <button type="button" className="btn btn-secondary" disabled>
          <i className="fas fa-cog fa-spin" /> Uploading...
        </button>
      );
    } else {
      return (
        <button type="submit" className="btn btn-secondary">
          Upload
        </button>
      );
    }
  }

  getForm(props: InqOfferAcceptedModalProps, state: InqOfferAcceptedModalState)  {
    return (
      <form className="hi-inqacceptmod__content" onSubmit={ (e) => this.onSubmit(e) }>
        { this.getOfferSelectionGroup() }

        <div className="hi-input-group">
          <label className="hi-input-group__label">Accepted Date</label>
          <DatePickerControl className="form-control" value={ state.acceptedDate }
            onChange={ linkState(this, 'acceptedDate') } />
        </div>

        <div className="hi-input-group">
          <label className="hi-input-group__label">Upload File (Optional)</label>
          <FileUploadFormControl selectedFiles={ state.selectedFiles }
            disabled={ props.offerReqState === ReqState.IN_PROGRESS }
            onChange={ linkState(this, 'selectedFiles', 'target.files') } />
        </div>

        <div className="text-center">
          { this.getSubmitButton() }
        </div>
      </form>
    );
  }

  getSuccessContent() {
    return (
      <div className="d-flex flex-column flex-fill justify-content-center">
        <div className="hi-inqacceptmod__transition-content">
          <h3 className="hi-inqacceptmod__transition-heading">Successful Upload</h3>

          <p className="hi-inqacceptmod__transition-text">Inquiry will be moved under Offer Accepted stage.</p>

          <div className="hi-inqacceptmod__transition-buttons">
            <button className="btn btn-secondary" onClick={ () => this.onProceed() }>Proceed to Offer Accepted</button>
            <button className="btn btn-outline-dark" onClick={ () => this.onTransitionCloseClick() }>Back</button>
          </div>
        </div>
      </div>
    );
  }

  render(props: InqOfferAcceptedModalProps, state: InqOfferAcceptedModalState) {
    return (
      <HopplerModalizer onClose={ () => null }>
        <div className="hi-inqacceptmod">
          <div className="hi-inqacceptmod__title-bar">
            <span className="hi-inqacceptmod__title-label">Upload Offer Accepted</span>
            <button className="btn btn-link hi-inqacceptmod__title-close" onClick={ props.onClose }>
              <i className="fas fa-times" /> Close
            </button>
          </div>

          { props.submitState !== ReqState.SUCCESS ? this.getForm(props, state) : this.getSuccessContent() }
        </div>
      </HopplerModalizer>
    )
  }

  componentWillReceiveProps(nextProps: InqOfferAcceptedModalProps) {
    if (nextProps.documentChoices && !this.props.documentChoices && nextProps.documentChoices.length > 0) {
      const latestDoc = nextProps.documentChoices[nextProps.documentChoices.length - 1];
      this.setState({ selectedLoiKey: latestDoc.loiKey });
    }
  }
}
